import styled from "styled-components";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { CustomIcon } from "components/icon/customIcon.component";

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0 20px;
  padding-right: 10px;
  width: 100%;
  border: none;
  background-color: white;
  color: ${Color.BurntSienna};
  font-family: ${FontFamily.LeagueSpartanBold};
  font-size: ${FontSize.H4};
  flex-grow: 1;
  cursor: pointer;
  overflow-x: clip;

  &:hover {
    background-color: ${Color.SeaBlue200};
  }

  p {
    white-space: nowrap;
  }
`;

export const IconHolder = styled.div`
  display: flex;
  margin-left: auto;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  justify-content: flex-start;
  text-align: left;
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${Color.SeaBlue200};
`;

export const StyledIcon = styled(CustomIcon)`
  margin: 0 4px;
`;

export const IconContainer = styled.div`
  background-color: ${Color.LighterDestructive};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out, transform 0.2s;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;
